// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"quantity-module--inputWrapper--34-Eq","styledInput":"quantity-module--styledInput--2Qz-O"};